import { isBrowser } from "utils/dom"

export const defaultTimeout = 100000
export const apiBaseUrl = isBrowser
  ? process.env.NEXT_PUBLIC_API_BASE_URL_V2
  : process.env.NEXT_PUBLIC_API_BASE_URL_V2_FOR_SERVER
